import styled from 'styled-components'

export const Centered = styled.div<{ margin: string }>`
  display: flex;
  justify-content: center;
  margin: ${({ margin }) => margin};
`
